import { Observable, of } from 'rxjs';
import { INotificationGroup } from '../dtos/responses/notification-group.model';
import { INotificationGroupsClient } from './i-notification-groups.client';
import { SystemRoleEnum } from '../../../../user-management/system-management/system-roles/enums/role-type.enum';
import { adminNotificationGroups, notificationGroups } from '../data/notification-groups.data';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NotificationGroupsClient implements INotificationGroupsClient {
    getByRoles(roles: string[]): Observable<INotificationGroup[]> {
        if (roles.includes(SystemRoleEnum.SYSTEM_GLOBAL_ADMIN)) {
            return of(adminNotificationGroups);
        }

        return of(notificationGroups.filter(group => roles.some(role => group.name.includes(role))));
    }
}
